<script lang="ts">
    import {getStats} from './services'
    import {currentErr,currentTyped,currentTimes} from './store'
    import {supabase} from './supaBase'
    import {onMount} from 'svelte'
    import {statsData} from './store'
    
    export const load = (item) => {
        if(item.detail){
            const obj = JSON.parse(item.detail);
            $currentErr = obj.err;
            $currentTyped = obj.typed;
            $currentTimes = obj.times;
        }
    };
   
</script>
<!-- {#await promise}
    Loading..
{:then data}  -->
    <table>
        <tr><th>WPM</th><th>Total Time(sec)</th><th>Accuracy</th><th>Real Accuracy</th><th>Date</th><th>Load</th></tr>
        {#each $statsData as item}
            <tr><td>{item.wpm}</td><td>{item.total_time_sec}</td><td>{item.accuracy}</td><td>{item.real_accuracy}</td><td>{item.inserted_at}</td><td><button on:click="{()=>load(item)}">Load</button></td></tr>
        {/each}
        
    </table>
<!-- {/await} -->

<style>
    table{
        margin:auto;
        border-collapse: collapse;
    }
    td, th {
        border: 1px solid #999;
        padding: 0.5rem;
        text-align: left;
    }
    th{
        background-color:lightgray;
    }
</style>